import { MainWorkflowStepSkippedBy } from '@osos/shared/api';
import { StepOwnerSelectionCriteriaEnum } from '../enums';
import { MainFlowStatusStepTypeEnum } from '../enums/mainflow-status-step-type-enum';
import { LocalizedValueModel } from '../localized-value.model';
import { RefProperty } from '../ref-property.model';
import { WorkflowActionPresenterModel } from './workflow-presenter-models/workflow-action-presenter.model';

export type StepExecutor = RefProperty & {
  onBehalfOf?: RefProperty;
  notes?: string;
  actionName?: LocalizedValueModel;
  actionDescription?: LocalizedValueModel;
  hasExecutedAction?: boolean;
  executionDate?: string;
};

export class DataEntryWorkflowStatusPresenterModel {
  workflowId: string;
  isMainFlowDetermined: boolean;
  steps: Step[];
}

export interface Step {
  id: string;
  type: MainFlowStatusStepTypeEnum;
  actions: WorkflowActionPresenterModel[];
  mainFlowIndex: number;
  name: LocalizedValueModel;
  description: LocalizedValueModel;
  notes: string;
  executedBy: StepExecutor[];
  owner?: RefProperty;
  originalOwner?: RefProperty | RefProperty[];
  recievedAt?: string;
  executedAt?: string;
  executors: {
    executedBy: RefProperty;
    delegatee?: RefProperty;
    owner?: RefProperty;
    action: string;
    executedAt: string;
    receivedAt: string;
    notes: string;
  }[];
  originalOwnerUsers?: Array<StepOriginalOwnerUsers>;
  stepOwnerSelectionCriteria?: StepOwnerSelectionCriteriaEnum;
  // V3 API support for nested sub-workflow steps
  subWorkflowId?: string;
  subWorkflowInstanceId?: string;
  subWorkflowSteps?: Step[];
  instanceId?: string;
  isAdhoc?: boolean;
  stepOwners?: StepExecutor[];
  parentStepId?: string;
  skippedBy?: MainWorkflowStepSkippedBy;
}
export class StepOriginalOwnerUsers {
  originalOwner?: RefProperty;
  users?: Array<RefProperty>;
}
